import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getCarousels } from '../actions/CarouselActions';
import DataTable from '../../common/DataTable/DataTable';
import { Link } from 'react-router-dom';
import { Button, Pane } from 'evergreen-ui';

class ListCarousel extends Component {
    handleTableChange = (opts) => {
        this.props.dispatch(getCarousels(opts));
    }

    render() {
        return (<>
            <Pane display="flex" marginBottom={16}>
                <Pane>
                    <Link to="/carousel/create">
                        <Button iconBefore="add" intent="none" appearance="primary">
                            Slide Nou
                        </Button>
                    </Link>
                </Pane>
            </Pane>
            <DataTable
                defaultFilter='id'
                defaultDirection='desc'
                columns={[
                    {id: 'id', label: 'Id'},
                    {id: 'title', label: 'Titlu'},
                    {id: 'active', label: 'Activ',  decorator: 'boolean'},
                    {id: 'position', label: 'Pozitie'},
                    {id: 'createdAt', label: 'Creat', decorator: 'date'},
                    {id: 'updatedAt', label: 'Modificat', decorator: 'date'}
                ]}

                data={this.props.data}

                onTableChange={this.handleTableChange}
                updateKey={this.props.data}
                page={this.props.page}
                pageSize={this.props.pageSize}
                pageCount={this.props.pageCount}

                itemMenu={[
                    { getLink: (item) => `/carousel/${item[0]}`, label: 'Detalii', icon: 'eye-open' },
                    { getLink: (item) => `/carousel/${item[0]}/edit`, label: 'Editeaza', icon: 'edit' }
                ]}
            />
        </>)
    }
}

function mapStateToProps(state) {
    return state.carousel;
}

export default connect(mapStateToProps)(ListCarousel);